import { useBlogSelectors } from "../../../../../store/blog/blog.selectors";

import { BlogCard } from "../../../../../components";
import { Pagination } from "../../../../../components/common/Pagination/Pagination";

import { BlogList, Wrapper } from "./CardList.styled";

export const CardList = () => {
  const { blogData } = useBlogSelectors();
  const { totalPages, content } = blogData;

  return (
    <Wrapper>
      <BlogList>
        {content
          ?.slice(0, 9)
          .map(({ title, description, createdDate, id, slug }, idx) => (
            <BlogCard
              key={id}
              index={idx}
              title={title}
              description={description}
              date={createdDate}
              slug={slug}
            />
          ))}
      </BlogList>

      {totalPages > 0 && <Pagination totalPages={totalPages} />}
    </Wrapper>
  );
};
